module.exports = __webpack_public_path__ + "img/partner-7.91b751ac.png";